import React from 'react';
import AboutHeroSection from '../components/AboutHeroSection';
import AboutWhoWeAreSection from '../components/AboutWhoWeAreSection';
import AboutOurMissionSection from '../components/AboutOurMissionSection';
import AboutOurVisionSection from '../components/AboutOurVisionSection';
import AboutWhatDrivesUsSection from '../components/AboutWhatDrivesUsSection';
import AboutOurCommitmentSection from '../components/AboutOurCommitmentSection';
import AboutCoreTeamSection from '../components/AboutCoreTeamSection';
import AboutTeamCardsSection from '../components/AboutTeamCardsSection';
import BlogSection from '../components/BlogSection';
import ContactUsSection from '../components/ContactUsSection';
import FooterSection from '../components/FooterSection';

function AboutUs() {
  return React.createElement('div', { className: 'figma-viewport' },
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutHeroSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutWhoWeAreSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutOurMissionSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutOurVisionSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutWhatDrivesUsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutOurCommitmentSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutCoreTeamSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(AboutTeamCardsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(BlogSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ContactUsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(FooterSection))
  );
}

export default AboutUs;
